<div class="rightPannelBox orderDetailsTab">
  <div class="row mb-10">
    <div class="col-lg-9">
      <h3>Order Details</h3>
    </div>
    <div class="text-right col-lg-3">
      <button (click)="orderListScreenCloseClick()" class="ba-btn ba-btn-sq-sm" role="button">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </div>
  <form [formGroup]="inputFormDetails">
    <div class="row m-2">
      <div class="col-sm-2">
        <label for="fromDateTime">From: </label><br />
        <input name="fromDateTime" class="form-control" formControlName="fromDateTime" type="datetime-local" step="1" />
        <div class="field-validation-valid text-danger" *ngIf="submitted && !inputFormDetails.value.fromDateTime">Invalid Date</div>
      </div>
      <div class="col-sm-2 ms-2">
        <label for="toDateTime">To: </label><br />
        <input name="toDateTime" class="form-control" formControlName="toDateTime" type="datetime-local" step="1" />
        <div class="field-validation-valid text-danger" *ngIf="submitted && !inputFormDetails.value.toDateTime">Invalid Date</div>
      </div>
      <div class="col-sm-2 ms-2 w-2">
        <label for="parameters">Ticketing Status: </label><br />
        <div class="col-sm-1 filter-dropdown">
          <select name="parameters" formControlName="parameters">
            <option *ngFor="let parameter of parameters" [value]="parameter">{{ parameter }}</option>
          </select>
        </div>
      </div>
      <div class="col-sm-2 ms-2">
        <br />
        <input type="button" class="ba-btn ba-btn-sq-sm results" (click)="showResults()" value="Show Results">
      </div>
      <ng-template [ngIf]="orderDetailsScreen.matchedOrders">
        <div class="col-sm-3 ms-3">
          <br />
          <div class="search-container">
            <input type="text" formControlName="searchPNR" class="searchInput" placeholder="Search Order ID" />
            <button class="serachBtn" (click)="getSearchedPNR()"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </ng-template>
    </div>
  </form>

  <div class="row">
    <div class="col-sm-5 center-flex">
      <ng-template [ngIf]="isTotNum && orderDetailsScreen.matchedOrders">
        <div class="m-2 bold">
          Total Number of Orders Created:
          {{ orderDetailsScreen.matchedOrders.length }}
        </div>
      </ng-template>
    </div>
    <ng-template [ngIf]="pages && pages.length > 0">
      <div class="col-sm-6 ms-1">
        <nav aria-label="Page navigation example">
          <ul class="pagination justify-content-end">
            <li class="page-item">
              <a (click)="previous()" class="page-link" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li *ngFor="let page of pages" class="page-item" [ngClass]="{ active: page === startValue }">
              <a (click)="showPage(page)" class="page-link">{{ page + 1 }}</a>
            </li>
            <li class="page-item">
              <a (click)="next()" class="page-link" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="pageLength">
        <select [(ngModel)]="itemsPerPage" (change)="updatePageLength(itemsPerPage)">
          <option *ngFor="let pageLength of pageLengthList" [selected]="pageLength === itemsPerPage" [value]="pageLength">{{ pageLength }}</option>
        </select>
      </div>
    </ng-template>
  </div>

  <div class="table-responsive">
    <table class="table table-fixed table-hover">
      <thead class="thead-light">
        <tr>
          <th scope="col" class="col-3">OrderID</th>
          <th scope="col" class="col-3">Creation Date-Time</th>
          <th scope="col" class="col-3">Order Status</th>
          <th scope="col" class="col-3">Ticketing Status</th>
        </tr>
      </thead>
      <tbody *ngIf="displayMatchedOrders.length > 0">
        <tr *ngFor="let orders of displayMatchedOrders;">
          <td scope="row" class="col-3">
            <span class="pnrSelection" (click)="findPNRDetails(orders)">
              {{ (orders['NS2:ORDERREFID'] && orders['NS2:ORDERREFID'][0]) || '' }}
            </span>
          </td>
          <td class="col-3">{{ formateDateTime(orders['NS2:CREATIONDATETIME'][0]) }}</td>
          <td class="col-3">{{ orders['NS2:ORDERSTATUSCODE'][0] }}</td>
          <td class="col-3">{{ orders['NS2:TICKETINGSTATUSCODE'][0] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
